var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { buildDevProps } from '../../helpers/builders';
var commonTypographyProps = function () { return ({
    type: 'p2',
    fontWeight: 'semiBold',
}); };
var commonProps = function () { return ({
    typographyProps: commonTypographyProps(),
    variant: 'filled',
    colorScheme: 'positive',
    bRadius: 'pill',
    px: 'xxs',
    py: 'nano',
}); };
var propsByVariant = function (theme, colorScheme) { return ({
    filled: {
        bWidth: 'none',
        bgColor: theme.brand.color.status[colorScheme],
        typographyProps: __assign(__assign({}, commonTypographyProps()), { color: theme.neutrals.pureWhite }),
    },
    flat: {
        bWidth: 'none',
        bgOpacity: 0.15,
        bgColor: theme.brand.color.status[colorScheme],
        typographyProps: __assign(__assign({}, commonTypographyProps()), { color: theme.brand.color.status[colorScheme] }),
    },
    light: {
        bWidth: 'hairline',
        bgOpacity: 0.1,
        bgColor: theme.brand.color.status[colorScheme],
        bColor: theme.brand.color.status[colorScheme],
        typographyProps: __assign(__assign({}, commonTypographyProps()), { color: theme.brand.color.status[colorScheme] }),
    },
}); };
var builderDefaultProps = function (devProps, theme) {
    var buildedProps = buildDevProps(commonProps(), devProps);
    return __assign(__assign({}, buildedProps), propsByVariant(theme, buildedProps.colorScheme)[buildedProps.variant]);
};
export var buildBadgeProps = function (devProps, theme) {
    var defaultProps = builderDefaultProps(devProps, theme);
    return buildDevProps(defaultProps, devProps);
};
